import PropTypes from 'prop-types';
import GradientBanner from '../GradientBanner';

import styles from './VehicleRecallBanner.module.css';

const VehicleRecallBanner = ({ children, ...rest }) => (
  <GradientBanner className={styles.banner} {...rest}>
    {children}
  </GradientBanner>
);

VehicleRecallBanner.propTypes = {
  children: PropTypes.node,
};

VehicleRecallBanner.defaultProps = {
  children: null,
};

export default VehicleRecallBanner;
